<page-load-header *ngIf="!initialized"></page-load-header>
<ng-container *ngIf="initialized">
  <div>
    <div *ngIf="!auth.user.stripeLinked" class="alert alert-warning" role="alert">
      When you produce content, you can earn money. The information below allows you to get Paid.
    </div>
    <div class="row no-gutters no-candidates" style="height: 300px;" *ngIf="!auth.user.stripeLinked">
      <div class="col-sm-12 my-auto">
        <h1><i class="fas fa-empty-set"></i></h1>
        <h4>No payment details exist yet.</h4>
        <p>Let's add some!</p>
        <a href="{{ stripeUrl }}" class="btn btn-instagram">Link Stripe Account</a>
      </div>
    </div>
    <div *ngIf="auth.user.stripeLinked">
      <div class="row">
        <div class="col">
          Member since {{ stripeData.memberSince | date: 'MMM, yyyy' }}
          <h2>{{ auth.user.firstName }} {{ auth.user.lastName }}</h2>
          <p><a target="_blank" href="{{ stripeDashboard + '&route=account' }}">View Stripe Account</a></p>
        </div>
        <div class="col">
          This week:
          <h3 class="mb-0">{{ stripeData.weeklySum | currency }}</h3>
          <p class="text-muted">{{ stripeData.weeklyCount }} Purchases</p>
        </div>
        <div class="col">
          Your Balance:
          <h3 class="mb-0">{{ stripeData.pending + stripeData.available | currency }}</h3>
          <p class="text-muted">{{ stripeData.available | currency }} Available</p>
        </div>
        <div class="col">
          <button type="button" class=" col btn btn-lg btn-alternate mr-1 ml-1">Pay out now</button>
          <p class="text-center"><a target="_blank" href="{{ stripeDashboard }}">View payouts on Stripe</a></p>
        </div>
      </div>
      <!-- <div class="row mt-5">
        <div class="col">
          <h5>Recent Transactions</h5>
          <table class="table">
            <tr *ngFor="let hire of stripeData.hires">
              <th class="border-0" scope="row">{{ hire.companyInvoicePublicDescription }}</th>
              <td class="border-0">{{ hire.companyInvoiceCreatedDate | timeAgo }}</td>
              <td class="border-0" *ngIf="hire.processed">{{ hire.amountTransacted | currency }}</td>
              <td class="border-0" *ngIf="!hire.processed">Pending ({{ hire.amount | currency }})</td>
            </tr>
          </table>
        </div>
      </div> -->
    </div>
  </div>
</ng-container>
